import { ProjectSubmission } from "@/javascript/project-objects";
import { Box, Group, Skeleton } from '@mantine/core';
import React from "react";
import VideoBlock from "./ProjectSubmissionVideoBlock";


interface VideoGridProps {
	projectSubmissions: ProjectSubmission[] | null | undefined;
	skeletonSize: number
}

const VideoGrid: React.FC<VideoGridProps> = ({ projectSubmissions, skeletonSize }) => {
	const isLoading = !projectSubmissions

	return (
		<Group
			w="100%"
			justify="center"
			style={{ margin: 0 }}
		>
			<Box
				w="100%"
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fit, minmax(300px, max-content))",
					gap: "2rem",
					justifyContent: "center",
				}}
			>
				{isLoading
					? Array.from({ length: skeletonSize }).map((_, i) => (
						<Skeleton key={i} h={300} w={300} radius="md" />
					))
					: projectSubmissions.map((projectSubmission) => (
						<VideoBlock
							key={projectSubmission.id}
							projectSubmission={projectSubmission}
						/>
					))}
			</Box>
		</Group>
	);
};

export default VideoGrid;